import React from "react";

function LatestMatch() {
  return (
    <section className="latest-match-area latest-match-bg pt-60 pb-60">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-8">
            <div className="section-title title-style-three white-title text-center mb-70">
              <h2>
                Why Choose <span>MOITRIBE?</span>
              </h2>
            </div>
          </div>
        </div>
        <div className="row">
          {/* True Multiplayer */}
          <div className="col-lg-6">
            <div className="latest-match-box mb-30">
              <div className="latest-match-thumb">
                <img
                  style={{
                    maxHeight: "200px",
                    width: "auto",
                    objectFit: "contain",
                  }}
                  src="assets/img/images/Tech - True Multiplayer.png"
                  alt="True Multiplayer"
                />
              </div>
              <div className="tournament-schedule-content">
                <h3 className="md-text-center" >
                  True <span>
                    Multiplayer
                  </span>
                </h3>
                <p className="md-text-center" >
                  A unique offering to the telco community. Powering hyper
                  casual games with multiplayer features like voice chat, video
                  chat, tournament, social gaming community, community to drive
                  user generated game content.
                </p>
              </div>
            </div>
          </div>

          {/* Codeless Ingestion */}
          <div className="col-lg-6">
            <div className="latest-match-box mb-30">
              <div className="latest-match-thumb">
                <img
                  style={{
                    maxHeight: "200px",
                    width: "auto",
                    objectFit: "contain",
                  }}
                  src="assets/img/images/Tech - Codeless ingestion.png"
                  alt="Codeless Ingestion"
                />
              </div>
              <div className="tournament-schedule-content">
                <h3 className="md-text-center" >
                    Simple & Easy <span>Ingestion</span>
                </h3>
                <p className="md-text-center" >
                  Our simple and easy ingestion wrapper has the ability to control access to content, alter advertisement channels, modify in-app purchase channels, and switch in-game multiplayer engines. This solution is unique and gives Telcos, Content Aggregators, and Smartphone OEMs a powerful tool to onboard game publishers effortlessly.
                </p>
              </div>
            </div>
          </div>

          {/* Game Store Front */}
          <div className="col-lg-6">
            <div className="latest-match-box mb-30">
              <div className="latest-match-thumb">
                <img
                  style={{
                    maxHeight: "200px",
                    width: "auto",
                    objectFit: "contain",
                  }}
                  src="assets/img/images/Tech -Store front.png"
                  alt="Game Store Front"
                />
              </div>
              <div className="tournament-schedule-content">
                <h3 className="md-text-center" >
                    Game Store <span>Front</span>
                </h3>
                <p className="md-text-center" >
                  Our revenue share model is already bringing success to OEMs
                  and telecom companies from all around the world. If you want
                  to create an alternate games/apps online store we have a ready
                  solution for you.
                </p>
              </div>
            </div>
          </div>

          {/* Developer Portal */}
          <div className="col-lg-6">
            <div className="latest-match-box mb-30">
              <div className="latest-match-thumb">
                <img
                  style={{
                    maxHeight: "200px",
                    width: "auto",
                    objectFit: "contain",
                  }}
                  src="assets/img/images/Tech - Developer portal.png"
                  alt="Developer Portal"
                />
              </div>
              <div className="tournament-schedule-content">
                <h3 className="md-text-center" >
                    Developer <span>Portal</span>
                </h3>
                <p className="md-text-center" >
                  Our game store solution is coupled with a developer platform.
                  The developer platform supports game developers to incorporate
                  monetisation via advertisement and payment channels
                  pre-configured. Developer benefits from additional content
                  discovery and revenue while your store gets new and fresh
                  content.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LatestMatch;
